<template>
  <div v-loading="loading" class="leftList" element-loading-text="数据加载中...">
    <div class="searchInput">
      <el-input v-model="keyWords" placeholder="请输入关键字" suffix-icon="el-icon-search" size="small"></el-input>
    </div>
    <div v-infinite-scroll="load" class="checkFlowList" :infinite-scroll-immediate="false" :infinite-scroll-delay="800">
      <div v-for="(item,index) in checkFlowList" :key="index"
        class="checkFlow" :class="{ active: item.businessId === activeIndex }" @click="checkFlowClick(item)">
        <!-- 图片 -->
        <span class="image">
          <img :src="flowImage" />
        </span>
        <span class="title" :title="item.title">
          {{ item.title }}
        </span>
        <span class="other">
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              <i class="el el-icon-more rowIcon" title="更多"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="beforeHandleCommand(item, 'flowDeatil')">
                查看详情
              </el-dropdown-item>
              <el-dropdown-item v-if="isShowButton" :command="beforeHandleCommand(item, 'flowAgree')">
                通过
              </el-dropdown-item>
              <el-dropdown-item v-if="isShowButton" :command="beforeHandleCommand(item, 'flowReject')">
                驳回
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </span>
      </div>
    </div>
    <el-dialog v-dialogDrag title="通过" :visible.sync="flowAgreeDialog" width="30%" :before-close="closeFlowAgreeDialog" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="warningMessage">
        <span class="image">
          <img :src="warning" />
        </span>
        <span class="warningMessageText">将对该流程进行通过操作，是否确认？</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeFlowAgreeDialog">取 消</el-button>
        <el-button type="primary" size="small" @click="agreeCheckFlow">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog v-dialogDrag title="驳回" :visible.sync="flowRejectDialog" width="30%" :before-close="closeFlowRejectDialog" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="reject">
        <el-row :span="24" style="margin-bottom:10px">
          <el-col :span="4">
            <span class="rejectRequired">*</span>
            <span class="rejectText">审批意见</span>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :span="24">
            <el-input v-model="comment" :autosize="{ minRows: 2, maxRows: 6 }" type="textarea" style="width: 100%"
              maxlength="200" show-word-limit placeholder="请输入审批意见"></el-input>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeFlowRejectDialog">取 消</el-button>
        <el-button type="primary" size="small" @click="rejectCheckFlow">确 定</el-button>
      </span>
    </el-dialog>
    <flowDialogSummary ref="flowDialogSummary" isProject :mode="approveType" :view="viewMode" @updateTable="updateTable" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import checkRegionService from "@/CommonDP/service/checkRegion-service";
import flowService from "@/CommonDP/service/flow-service";
import flowDialogSummary from "@/CommonDP/components/processComponents/flow/flowDialogSummary.vue";
// import FlowDetailRouteHelper from "@/CommonDP/pages/components/launchFlow/FlowDetailRouteHelper";
export default {
  name: "",
  components: { flowDialogSummary },
  mixins: [],
  props: {
    activeName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      flowImage: require("../image/flowImage.png"),
      warning: require("../image/warning.png"),
      keyWords: "",
      checkFlowList: [],
      activeIndex: "",
      loading: false,
      flowAgreeDialog: false,
      flowRejectDialog: false,
      comment: "",
      flowInstanceNodeId: "",
      neverChangeList: [], // 永不改变的数组 用来搜索
      rightFileList: [],
      page: {
        pageNum: 1,
        pageSize: 20,
        totalPage: 1
      },
      viewMode: 1, // 审批1 查看2
      approveType: ""
    };
  },
  computed: {
    ...mapState({
      prjInfo: state => state.projectMg.prjObj,
      enterpriseId: state => state.enterprise.enterpriseId,
      userInfo: state => state.user.userInfo
    }),
    isShowButton() {
      if (this.activeName === "myAgency") {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    keyWords() {
      this.getFlowList(this.activeName, 1);
    }
  },
  created() {},
  mounted() {},
  methods: {
    load() {
      if (this.page.totalPage > this.page.pageNum) {
        this.page.pageNum++;
        this.getFlowList(this.activeName);
      }
    },
    filterKeyword(item, name) {
      const keyArr = ["title"];
      let flag = false;
      while (keyArr[0] && !flag) {
        if (item[keyArr.shift()].includes(name)) flag = true;
      }
      return flag;
    },
    updateTable() {
      this.getFlowList(this.activeName);
    },
    async getFlowList(activeName, val) {
      try {
        this.loading = true;
        if (val) {
          this.page.pageNum = 1;
          this.page.totalPage = 1;
          this.checkFlowList = [];
        }
        const pageNum = this.page.pageNum;
        const pageSize = this.page.pageSize;
        const enterpriseId = this.enterpriseId;
        const prjId = this.prjInfo.prjId;
        const title = this.keyWords;
        let service;
        if (activeName === 'mySubmit') {
          service = await checkRegionService.getMySubmitList(enterpriseId, prjId, pageNum, pageSize, title);
        } else if (activeName === 'myAgency') {
          service = await checkRegionService.getMyAgencyList(enterpriseId, prjId, pageNum, pageSize, title);
        } else {
          service = await checkRegionService.getMyFinishedList(enterpriseId, prjId, pageNum, pageSize, title);
        }
        const { data, pageIndex, totalPage } = await service;
        if (pageIndex !== 1) {
          this.checkFlowList = [...this.checkFlowList, ...data];
        } else {
          this.checkFlowList = data;
        }
        this.page.totalPage = totalPage;
        this.loading = false;
        this.neverChangeList = this.checkFlowList;
        if (val) {
          this.initActiveIndex(this.checkFlowList);
        }
      } catch (e) {
        // 接口报错，数据清空
        this.checkFlowList = [];
        this.$emit("getRightTableData", { businessId: "", currentNodeName: "" });
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
    // 初始化
    initActiveIndex(list) {
      if (list.length > 0) {
        this.activeIndex = list[0].businessId;
        if (this.activeName === "myAgency") this.$emit("getFlowBusinessId", list[0].flowBusinessId);
        this.$emit("getRightTableData", list[0]);
      } else {
        this.activeIndex = "";
        this.$emit("getRightTableData", { businessId: "", currentNodeName: "" });
      }
    },
    checkFlowClick(item) {
      this.activeIndex = item.businessId;
      if (this.activeName === "myAgency") this.$emit("getFlowBusinessId", item.flowBusinessId);
      this.$emit("getRightTableData", item);
    },
    beforeHandleCommand(row, command) {
      return { row: row, command: command };
    },
    handleCommand(command) {
      switch (command.command) {
        case "flowDeatil": // 详情
          this.flowDeatil(command.row);
          break;
        case "flowAgree": // 通过
          this.flowAgree(command.row);
          break;
        case "flowReject": // 驳回
          this.flowReject(command.row);
          break;
      }
    },
    async flowDeatil(row) {
      const res = await flowService.queryInstanceNodes(row.flowInstanceId);
      const nodeList = res.data || [];
      const list = nodeList.filter((ele) => ele.nodeStatus === "2")[0]?.assigneeList || []; // 审批人集合
      if (list.some((e) => e.userId === this.userInfo.userId)) {
        this.viewMode = 1; //  审批1 查看2
      } else {
        this.viewMode = 2;
      }
      const params = {
        ...row,
        name: row.flowName
      };
      this.approveType = "edit";
      this.$refs.flowDialogSummary.openEditDialog(params);
      // debugger;
      // const params = {
      //   ...row,
      //   title: "",
      //   viewParam: "view",
      //   readonly: true, // 用以替换 flowStatus
      //   flowStatus: true,
      //   isCheckRegion: true
      // };

      // if (this.activeName === "mySubmit") params.title = "mySubmit";
      // if (this.activeName === "myAgency") params.title = "pending";
      // if (this.activeName === "myFinished") params.title = "pending";

      // this.$store.dispatch("setRouterParams", params);
      // if (params.status === 2) {
      //   const list = nodeList.filter(ele => ele.nodeStatus === "2")[0].assigneeList; // 审批人集合
      //   list.forEach(ele => {
      //     if (ele.userId === this.userInfo.userId) {
      //       params.viewParam = "approve";
      //     }
      //   });
      //   if (params.viewParam === "approve") {
      //     FlowDetailRouteHelper.routeToApproval(this, params);
      //   } else {
      //     FlowDetailRouteHelper.routeToViewDetail(this, params);
      //   }
      // } else {
      //   FlowDetailRouteHelper.routeToViewDetail(this, params);
      // }
    },
    // 通过
    async flowAgree(row) {
      this.$emit("getFileList");
      const list = this.rightFileList.filter(ele => ele.isRead === 0);
      if (list.length) return this.$warn("有文件未打开查看，请打开查看文件！");
      this.flowInstanceNodeId = row.currentNodeId;
      this.flowAgreeDialog = true;
    },
    setFileList(list) {
      console.log(list);
      this.rightFileList = list;
    },
    async agreeCheckFlow() {
      const params = {
        flowInstanceNodeId: this.flowInstanceNodeId
      };
      await checkRegionService.agree(params);
      this.$success("通过流程成功！");
      this.getFlowList(this.activeName);
      this.closeFlowAgreeDialog();
    },
    closeFlowAgreeDialog() {
      this.clearParams();
      this.flowAgreeDialog = false;
    },
    // 驳回
    async flowReject(row) {
      this.flowInstanceNodeId = row.currentNodeId;
      this.flowRejectDialog = true;
    },
    async rejectCheckFlow() {
      if (this.comment === "") return this.$warn("请输入审批意见！");
      const params = {
        comment: this.comment,
        flowInstanceNodeId: this.flowInstanceNodeId
      };
      await checkRegionService.rejectNodeFlow(params);
      this.$success("驳回流程成功！");
      this.getFlowList(this.activeName);
      this.closeFlowRejectDialog();
    },
    closeFlowRejectDialog() {
      this.clearParams();
      this.flowRejectDialog = false;
    },
    // 清空参数
    clearParams() {
      this.flowInstanceNodeId = "";
      this.comment = "";
    }
  }
};
</script>

<style scoped lang="scss">
.leftList {
  width: 300px;
  height: 100%;
  border-right: 1px #e5e8f1 solid;
  display: flex;
  flex-direction: column;
  .searchInput {
    padding: var(--middle-space) var(--big-space);
  }
  .checkFlowList {
    padding: 0 var(--big-space);
    height: 1px;
    flex-grow: 1;
    overflow-y: auto;
    .checkFlow {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;
      margin: 5px;
      .image {
        width: 30px;
        height: 30px;
        line-height: 40px;
        text-align: center;
      }
      .title {
        width: 230px;
        font-weight: 400;
        font-size: 14px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .other {
        width: 15px;
        cursor: pointer;
      }
    }
    .active {
      background: #e5edff;
    }
  }
}
.warningMessage {
  display: flex;
  justify-content: center;
  align-items: center;
  .warningMessageText {
    font-weight: 400;
    font-size: 14px;
  }
}
.reject {
  .rejectRequired{
    color: #f56c6c;
    margin-right: 4px;
  }
  .rejectText {
    font-weight: 400;
    font-size: 14px;
  }
}
</style>
